import { css } from '@emotion/react';
import { IonItem, IonText } from '@ionic/react';
import React from 'react';
import SearchedLocationMarker from '../../assets/img/searched_location_marker.svg?react';
import { useLocation } from '../../contexts/LocationContext';
import { useSettings } from '../../contexts/SettingsContext';
import * as commonCss from '../../styles/common';
import { DistanceUnitSystem } from '../../types/distance';
import { LocationType } from '../../shared/location-type';

interface DistanceFromLocationProps {
  onClose: () => void;
}

const MyLocationMarker: React.FC = () => {
  const myLocationMarkerCss = {
    icon: css({
      backgroundColor: '#1da1f2',
      borderRadius: '50%',
      height: '1.125em',
      width: '1.125em',
      border: '2px solid white',
    }),
  };
  return <div css={myLocationMarkerCss.icon} />;
};

export const DistanceFromLocation: React.FC<DistanceFromLocationProps> = () => {
  const { marker, network } = useSettings();
  const { lastSelectedLocation, lastSelectedLocationType, computeDistance } = useLocation();

  const location = React.useMemo(() => marker?.location, [marker]);
  const distanceUnit = React.useMemo(() => {
    if (!network) {
      return null;
    }
    return network.distanceUnitSystem === DistanceUnitSystem.Imperial ? 'miles' : 'kilometers';
  }, [network]);

  const distance = React.useMemo(() => {
    if (location && lastSelectedLocation && distanceUnit) {
      return computeDistance(location, lastSelectedLocation, distanceUnit);
    }
    return null;
  }, [location, lastSelectedLocation, distanceUnit]);

  const locationType = React.useMemo(() => {
    if (lastSelectedLocationType === LocationType.SearchedLocation) {
      return 'searched';
    }
    return 'my';
  }, [lastSelectedLocationType]);

  const distanceFromLocationCss = {
    text: [commonCss.italics, commonCss.smallText, css({ marginLeft: '.25rem' })],
    icon: css({ height: '1em', width: '1em' }),
  };

  return (
    distance && (
      <IonItem lines="none">
        <div css={distanceFromLocationCss.icon}>
          {lastSelectedLocationType === LocationType.SearchedLocation ? (
            <SearchedLocationMarker />
          ) : (
            <MyLocationMarker />
          )}
        </div>
        <IonText css={distanceFromLocationCss.text}>
          Distance from {locationType} location: {distance < 100 ? distance.toFixed(2) : distance.toFixed(0)}{' '}
          {distanceUnit}
        </IonText>
      </IonItem>
    )
  );
};
